import ETextInput from '@/components/everridge/ETextInput';
import EToogler from '@/components/everridge/EToogler';
import InformationIconSolid from '@/components/icons/InformationIconSolid';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SettingsFormData } from '@/features/settings/SettingsPage';
import { cn } from '@/lib/utils';

type Props = {
	control: Control<SettingsFormData>;
	isMobile?: boolean;
};

const SettingsBookingDetails: FC<Props> = ({ control, isMobile }) => {
	const { t } = useTranslation();

	return (
		<div
			className={cn(
				'w-full p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
				isMobile && 'w-full p-0 border-0 bg-popover-30',
			)}>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.settings.components.booking.title')}
			</h3>
			<EToogler
				control={control}
				fieldName={'ordersEnabled'}
				label={t('elements.form.ordersEnabled.label')}
				placeholder={t('elements.form.ordersEnabled.placeholder')}
				text={t('main.settings.form.ordersEnabled.text')}
			/>
			<div className={cn('flex gap-4', isMobile && 'flex-col')}>
				<ETextInput
					control={control}
					fieldName={'reservationDaysBeforeToCancel'}
					type='number'
					label={t(
						'elements.form.reservationDaysBeforeToCancel.label',
					)}
					placeholder={t(
						'elements.form.reservationDaysBeforeToCancel.placeholder',
					)}
				/>
				<ETextInput
					control={control}
					fieldName={'reservationDaysBeforeToEdit'}
					type='number'
					label={t('elements.form.reservationDaysBeforeToEdit.label')}
					placeholder={t(
						'elements.form.reservationDaysBeforeToEdit.placeholder',
					)}
				/>
			</div>
			<div className={cn('flex gap-4', isMobile && 'flex-col')}>
				<ETextInput
					control={control}
					fieldName={'orderDaysBeforeToCancel'}
					type='number'
					label={t('elements.form.orderDaysBeforeToCancel.label')}
					placeholder={t(
						'elements.form.orderDaysBeforeToCancel.placeholder',
					)}
				/>
				<ETextInput
					control={control}
					fieldName={'orderDaysBeforeToEdit'}
					type='number'
					label={t('elements.form.orderDaysBeforeToEdit.label')}
					placeholder={t(
						'elements.form.orderDaysBeforeToEdit.placeholder',
					)}
				/>
			</div>
			<div className='p-3.5 flex gap-2 border border-popover-100 rounded-semi-xl bg-popover-10'>
				<InformationIconSolid className='size-4 shrink-0' />
				<p className='text-xs font-medium text-popover-800'>
					{t('main.settings.components.booking.text')}
				</p>
			</div>
		</div>
	);
};

export default SettingsBookingDetails;
